<template >
  <div class="app animated fadeIn"  style=" background-image: url('img/Login-Page-BG.png'); background-size: cover; background-position:center ;">
    <div class="container" >
      <b-row >
          <b-img fluid-grow src="img/brand/Login-Page-Header.png" style="height :70%;" />        
      </b-row>
      <b-row class="pt-2">
        <!-- kaba image -->
        <b-col sm="" class="">
          <b-img rounded fluid src="img/kaba.jpg" />
        </b-col>
        <!-- login card -->
        <b-col sm="4">
            <!-- <b-card no-body > -->
              <!-- <b-card-body> -->
                <!-- form -->
                <b-form @submit="login">
                  <h3 class="text-center">Login</h3>
                  <!-- username -->
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input id="user" type="text"
                     v-model="user"
                     class="form-control" placeholder="Username" required />
                  </b-input-group>
                  <!-- password -->
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input id="pass" type="password" class="form-control" 
                    placeholder="Password" 
                    v-model="password"
                    autocomplete="current-password" required/>
                    <b-input-group-append>
                      <b-button @click="toggle" >show</b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <!-- login buttom -->
                  <b-row class="justify-content-center">
                      <b-button type="submit" variant="primary" size="lg" class="px-4">Login</b-button>                    
                  </b-row>
                </b-form>
              <!-- </b-card-body> -->
            <!-- </b-card> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueNotifications from 'vue-notifications'

export default {
  name: 'Login',
  data() {
    return {
      user: null,
      password:null
    }
  },
  methods: {
    login(evt){
      evt.preventDefault();
      //can login
      // axios.get('http://192.168.100.107:8080/pilgrimDB/login.php',
      axios.get('pilgrimDB/login.php',
        {
          params:{
            user:this.user, 
            password:this.password,
          },
          withCredentials: true
        }
      )
      .then(response=>{
        // console.log(response)
        if(response.data==1){
          this.showSuccessMsg({title:"logged in", timeout:1500, position:"topCenter"})
          this.$router.push({name:'Dashboard'})
        }
        else{
          this.showErrorMsg({title:"Invalid password", timeout:3000})
        }
      })
      .catch(error=>{
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      })
      
      //any error user not found, network error 
    },
    toggle(evt){
      if( evt.target.innerText=='show'){
        evt.target.innerText="hide";
        evt.path[2].childNodes[3].type="text";
      }
      else{
        evt.target.innerText="show";
        evt.path[2].childNodes[3].type="password";
      }
      // console.log(evt);
    }
  },
  notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        message: '',
        position: "topRight",
        timeout: 5000
      },
      showInfoMsg: {
        type: VueNotifications.types.info,
        title: '',
        message: '',
        position: "topRight",
        timeout: 5000

      },
      showWarnMsg: {
        type: VueNotifications.types.warn,
        title: '',
        message: '',
        position: "topRight",
        timeout: 10000

      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        message: '',
        position: "topRight",
        timeout: 10000
      }
  }
}
</script>

<style>
#user,#pass{
  color: black;
  /* font-size: 15px; */
}
</style>
